import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig, selectNcFiles, selectNcFileId } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { NCFileTraceabilityContent } from '@v2/pages/common/components/NCFileTraceabilityContent';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

const PartDetailsNCFileTraceability: FC = () => {
  const dispatch = useAppDispatch();
  const ncFiles = useSelector(selectNcFiles);
  const ncFileId = useSelector(selectNcFileId);
  const title = useTitle();

  usePartDetails({
    clearTools: () => dispatch(clearTools()),
    getNCFileByPartId: (id, filters) => dispatch(getNCFileByPartId(id, filters)),
    getTools: (params) => dispatch(getTools(params)),
    getProductionBatchByPart: (params) => dispatch(getProductionBatchByPart(params)),
    updateHeaderConfig: (config) => dispatch(updateHeaderConfig(config)),
    getPartByID: (id) => dispatch(getPartByID(id)),
    operationsSearch: (params) => dispatch(operationsSearch(params)),
    getAllNcFiles: true,
  });

  // Part can link many NC files — anchor the graph on the first of the loaded list.
  const anchorNcFileId = ncFiles.data?.[0]?.ncFileId ?? ncFileId ?? null;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <NCFileTraceabilityContent ncFileId={anchorNcFileId} resolving={!ncFiles.wasLoaded} />
      </View>
    </DetailsPageWrapper>
  );
};

export { PartDetailsNCFileTraceability };
